// extracted by mini-css-extract-plugin
export var assigneeBadge = "_m0-0";
export var assigneeDetails = "_m0-1";
export var assigneeInfo = "_m0-2";
export var dropdownContainer = "_m0-4";
export var dropdownImage = "_m0-5";
export var editAssigneeInfo = "_m0-3";
export var editAssigneeModalContainer = "_m0-6";
export var hidden = "_m0-8";
export var input = "_m0-7";